module.exports = __webpack_public_path__ + "assets/img/order_11.5352004b.svg";